// extracted by mini-css-extract-plugin
export default {"wrap":"KanbanPage_wrap__vhDrP","KanbanPage":"KanbanPage_KanbanPage__G8zAt","showModal":"KanbanPage_showModal__h+mVu"};